function initCardSwatches(root) {
  var container = root || document;
  container.querySelectorAll('.card-swatch').forEach(function (swatch) {
    if (swatch.dataset.swatchInit) return;
    swatch.dataset.swatchInit = 'true';

    swatch.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const cardId = this.dataset.cardId;
      const imageUrl = this.dataset.image;
      if (!imageUrl) return;

      document.querySelectorAll('[data-card-id="' + cardId + '"]').forEach(function (s) {
        s.classList.remove('card-swatch--selected');
      });

      this.classList.add('card-swatch--selected');

      const img = document.getElementById('card-image-' + cardId);
      if (img) {
        img.src = imageUrl;
        img.srcset = imageUrl;
      }
    });
  });
}

// 初回実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { initCardSwatches(); });
} else {
  initCardSwatches();
}

// 動的に追加されたコンテンツにも対応
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType === 1) {
        initCardSwatches(node);
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });
